import { Component, OnInit } from '@angular/core';
import { Utils } from 'src/app/common/utils';
import { UntypedFormBuilder, UntypedFormGroup, Validators, FormControl } from '@angular/forms';
import { VproService } from 'src/app/service/vpro/vpro.service';
import { NgxSpinnerService } from 'ngx-spinner';
import Swal from 'sweetalert2';
import moment from 'moment';
import { CouponDetails } from 'src/app/models/CouponDetails';

const Toast = Swal.mixin({
  toast: true,
  position: "top",
  showConfirmButton: false,
  timer: 3500,
});

@Component({
  selector: 'app-coupons-generate',
  templateUrl: './coupons-generate.component.html',
  styleUrls: ['./coupons-generate.component.css']
})
export class CouponsGenerateComponent implements OnInit {

  coupApplicableTo: string[] = [
    Utils.COUPON_APPLICABLE_TO.ALL,
    Utils.COUPON_APPLICABLE_TO.INDIVIDUAL,
  ];
  currentDate = Utils.maxDate;
  coupon: CouponDetails;

  constructor(
    private _formBuilder: UntypedFormBuilder,
    private service: VproService,
    private spinner: NgxSpinnerService,
    private utils: Utils,
  ) { }

  couponGenerateForm: UntypedFormGroup;

  ngOnInit() {
    this.couponGenerateForm = this._formBuilder.group({
      description: ['', [Validators.required]],
      discount_percent: ['', [Validators.required, Validators.pattern(Utils.percentageRegex)]],
      valid_from: ['', [Validators.required]],
      valid_to: ['', [Validators.required]],
      scope: ['', [Validators.required]]
    })
  }

  showToast(type, title) {
    Toast.fire({
      type: type,
      title:
        title
    });
  }

  couponCreate() {
    let data = { ...this.couponGenerateForm.value };
    let { year: startYear, month: startMonth, day: startDay } = this.couponGenerateForm.value.valid_from;
    let { year: endYear, month: endMonth, day: endDay } = this.couponGenerateForm.value.valid_to;
    data["valid_from"] = moment((startYear + "-" + startMonth + "-" + startDay), 'YYYY-MM-DD').startOf('day').utc().valueOf();
    data["valid_to"] = moment((endYear + "-" + endMonth + "-" + endDay), 'YYYY-MM-DD').endOf('day').utc().valueOf();

    this.spinner.show();
    this.service.generateCoupon(data).subscribe(res => {
      this.spinner.hide();
      this.coupon = res;
      this.showMessage("Coupon Generated - Coupon Id " + this.coupon.id, 'success')
      this.couponGenerateForm.reset();
    }, err => {
      // console.log(err);
      this.spinner.hide();
      if (err.message.message === "Invalid Date") {
        this.showToast('error', "Valid To - date should be greater than today");
      }
      else {
        this.showToast('error', "Something went wrong");
      }

    });
  }

  showMessage(message, type) {
    Swal.fire({
      title: message,
      type: type
    })
  }

}
